import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { QueryErrorResetBoundary } from '@mint-lib/error-boundary';
import { QueryClientProvider } from '@mint-lib/query-client';

import { ApprovalFlowFallback } from '../error-boundary/ApprovalFlowFallback.jsx';
import { queryClient } from '../queries/client.js';
import type { InnerObject } from '../types.js';
import ApprovalStatusBar from './organisms/ApprovalStatusBar.jsx';

export default function ApprovalStatusBarRoot({
  innerObj,
  isDisabled,
}: {
  innerObj: InnerObject;
  isDisabled?: boolean;
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <QueryErrorResetBoundary fallback={<ApprovalFlowFallback />}>
        <ApprovalStatusBar innerObj={innerObj} isDisabled={isDisabled} />
        <ReactQueryDevtools initialIsOpen />
      </QueryErrorResetBoundary>
    </QueryClientProvider>
  );
}
